class _TvQuoteUtils {
    public replaceNaN (price: number): number | undefined {
        return !isNaN(price) ? price : undefined;
    }
}

export const TvQuoteUtils = new _TvQuoteUtils();
